<div class="flex items-end gap-3">
  <div class="flex-1">
    <app-form-control label="Kupon rabatowy">
      <input
        [fluid]="true"
        [formControl]="discountFormControl"
        pInputText
        placeholder="Wprowadź kod kuponu" />
    </app-form-control>
  </div>

  <div class="mb-6">
    <p-button
      (onClick)="handleSubmitClick()"
      appPrimengButton
      label="Wykorzystaj kupon" />
  </div>
</div>
